import React, { useEffect, useState } from 'react';
import useDashboardContext from 'contexts/dashboard.context';
import PageHeaderText from 'components/base/page-header-text';
import FormStepper from 'components/base/form-stepper';
import UpdateVendorDetails from './update-vendor-details';
import useVendorContext from 'contexts/vendor.context';
import { apiService } from 'services/base.service';
import { useNavigate } from 'react-router-dom';
import { MAIN_STORE_ROUTE_KEYS } from 'utils/constants';
import { DefaultVendorToEdit } from 'contexts/vendor.context/provider';
import { toast } from 'react-toastify';
import { ToastMessage } from '@cokitchen/cokitchen-components';

const EditVendorDetails = () => {
  const { setIsBackLink, setBackLinkTitle } = useDashboardContext();
  const { vendorToEdit, setVendorToEdit } = useVendorContext();
  const [vendor, setVendor] = useState(vendorToEdit);
  const [disabled, setDisabled] = useState(true);
  const [isUpdatingVendor, setIsUpdatingVendor] = useState(false);

  const router = useNavigate();

  useEffect(() => {
    setIsBackLink(true);
    setBackLinkTitle('Return to procurement');
    return () => {
      setIsBackLink(false);
      setBackLinkTitle('');
    };
  }, []);

  const isDisabled = () => {
    if (
      !vendor.name ||
      !vendor.phone_number ||
      !vendor.bank_name ||
      !vendor.account_name ||
      !vendor.account_number
    ) {
      setDisabled(true);
    } else {
      setDisabled(false);
    }
  };

  useEffect(() => {
    isDisabled();
  }, [vendor]);

  const parsePaymentPeriodToNumber = (value?: string) => {
    const parsed = Number(
      String(value)
        .replace(/\s*days?$/i, '')
        .trim()
    );
    return Number.isNaN(parsed) ? 0 : parsed;
  };

  const updateVendor = async () => {
    const data = {
      name: vendor?.name,
      phone_number: vendor?.phone_number,
      bank_name: vendor?.bank_name,
      account_number: vendor?.account_number,
      account_name: vendor?.account_name,
      payment_period: parsePaymentPeriodToNumber(vendor?.payment_period)
    };

    try {
      setIsUpdatingVendor(true);
      const res = await apiService.put(`vendors/${vendor.id}`, { data });
      if (res) {
        router(MAIN_STORE_ROUTE_KEYS.VENDORS);
        setVendorToEdit(DefaultVendorToEdit);
        toast(<ToastMessage message='Vendor updated successfully' type='success' />);
      }
    } catch (err: any) {
      toast(
        <ToastMessage message={err.response.data.message || 'Error updating vendor'} type='error' />
      );
    } finally {
      setIsUpdatingVendor(false);
    }
  };

  return (
    <div>
      <PageHeaderText title={`Edit ${vendorToEdit.name}`} description="Update vendors' details" />
      <div className='w-[400px] md:w-[670px]'>
        <FormStepper
          title='Update vendor details'
          hideSteps
          step={1}
          noOfSteps={1}
          setStep={() => {
            return;
          }}
          handleConfirmClick={updateVendor}
          handleCancelClick={() => router(-1)}
          disabled={disabled}
          loading={isUpdatingVendor}>
          <div>
            <UpdateVendorDetails vendor={vendor} setVendor={setVendor} />
          </div>
        </FormStepper>
      </div>
    </div>
  );
};

export default EditVendorDetails;
